module.exports = __webpack_public_path__ + "static/media/paint.270329c3.svg";